<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售折扣详情</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="conditions.state == 0 && role.ROLE === 'WLY001' ">
          <form-button @click="changeStatus('SUBMIT')">通过</form-button>
          <form-button @click="changeStatus('CANCEL')">驳回</form-button>
        </template>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        :disabled="isEdit"
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售折扣编码">
              <el-input
                v-model="conditions.fee_code"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端编码">
              <el-input v-model="conditions.terminal_code" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端描述">
              <el-input v-model="conditions.terminal_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经销商编码">
              <el-input v-model="conditions.dealer_code" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经销商名称">
              <el-input v-model="conditions.dealer_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态" prop="customer">
              <el-input v-model="conditions.state_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品编码">
              <el-input
                v-model="conditions.product_code"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品名称">
              <el-input v-model="conditions.product_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="总金额">
              <el-input v-model="conditions.total_amount" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细" :custome-config="() => vxeShowCustom('yTable')">
        <vxe-grid
          ref="yTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsDetail.columns"
          :data="gridOptionsDetail.data"
        />
      </TableCommon>
      <TableCommon title="操作记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiSalePlanCreate } from '@/api/sap/sale-plan'
import { mapGetters } from 'vuex'
import { getDhkById,getSubmitDhk } from '@/api/sap/signing-sap'

export default {
  components: {
  },
  data() {
    const rules = {
    }
    return {
      rules,
      mode: 'add',
      showEdit: false,
      selectDataOptions: {},
      loading: false,
      provinceList: [],
      errorList: [],
      cityList: [],
      conditions: {
        
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'status_text', title: '操作状态' },
          { field: 'changin_date', title: '处理日期' },
          { field: 'changin_time', title: '处理时间' }
        ]
      },
      gridOptionsDetail: {
        data: [],
        columns: [
          { field: 'item_code', title: '行号' },
          { field: 'bar_code', title: '箱码' },
          { field: 'bottle_code', title: '瓶码' },
          { field: 'amount', title: '金额' },
          { field: 'act_name', title: '活动名称' },
          { field: 'project_report', title: '立项报告' },
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      return false
    }
  },
  created() {
    this.getIdDetail()
  },

  methods: {
    async getIdDetail(){
      const {code} = this.$route.query
      const params = {
            fee_code: code,
            user_bp: this.role.USER_BP,
            role: this.role.ROLE,
          }
          this.errorList = []
          const {data:{head, history, item}} = await getDhkById(params)
          this.conditions = {
            ...head
          }
          this.gridOptions.data  = [...history]
          this.gridOptionsDetail.data  = [...item]
    },
    // 保存 提交 取消
    async changeStatus(mode) {
      const params = {
            mode,
            user_bp: this.role.USER_BP,
            data: [this.conditions],
          }
      const res = await getSubmitDhk(params)
      if (res.msgtype === 'E') {
        this.errorList.push(res.message)
        return
      }
      this.$message.success(res.message)
      this.getIdDetail()
    },
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 24px 16px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/loan-manage/loan-detail.vue